// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLClaimDetailsSelfServe__fix-max-width{max-width:unset!important}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-claim-react/components/MLClaimDetailsSelfServe/MLClaimDetailsSelfServe.module.scss"],"names":[],"mappings":"AAAA,6CACI,yBAAA","sourcesContent":[".fix-max-width{\n    max-width: unset !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fix-max-width": "app__MLClaimDetailsSelfServe__fix-max-width"
};
export default ___CSS_LOADER_EXPORT___;
